<li class="rs-padding-top3-so"><!-- //NOSONAR -->
  <a href="javascript:void(0)" (click)="downloadCsv()" data-tms-event="button-click" [attr.data-cy]="dataCy"
    [attr.data-tms-button-zone]="buttonZone" data-tms-button-name="Export all usage data (CSV, 100ko)"
    [attr.aria-disabled]="isDownloadInProgress" [attr.data-tms-context]="documentReference"
    [attr.data-tms-message-info]="billingAccountNumber">{{ 'bills.summary.downloadCSVButtonLabel' | translate
    }}<span class="rs-link-download-info">{{
      'bills.summary.downloadCSVButtonSubLabel' | translate
      }}</span></a>
</li>